module.exports = __webpack_public_path__ + "static/media/sds.d326f0df.png";